import { getApps, initializeApp, type FirebaseApp } from "firebase/app";

type FirebaseConfig = {
  apiKey: string | undefined;
  authDomain: string | undefined;
  projectId: string | undefined;
  storageBucket: string | undefined;
  messagingSenderId: string | undefined;
  appId: string | undefined;
  measurementId: string | undefined;
};

const firebaseConfig: FirebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const hasFirebaseConfig = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId &&
    firebaseConfig.appId,
);

const hasAnalyticsConfig = Boolean(
  hasFirebaseConfig && firebaseConfig.measurementId,
);

export function getFirebaseApp(): FirebaseApp | null {
  if (!hasFirebaseConfig || typeof window === "undefined") {
    return null;
  }

  return getApps()[0] ?? initializeApp(firebaseConfig);
}

export async function activateFirebaseAnalytics() {
  if (!hasAnalyticsConfig || typeof window === "undefined") {
    return null;
  }

  try {
    const app = getFirebaseApp();

    if (!app) {
      return null;
    }

    const { getAnalytics, isSupported } = await import("firebase/analytics");

    if (!(await isSupported())) {
      return null;
    }

    return getAnalytics(app);
  } catch (error) {
    console.info("Firebase Analytics was not initialized.", error);
    return null;
  }
}
